<template>
  <TableComponent :table="table">
    <template v-for="(_, slot) of $slots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope || {}" />
    </template>
  </TableComponent>
</template>
<script
  lang="ts"
  setup
  generic="
    T_Item extends Record<string, any>,
    T_Filter extends FilterBase,
    T_Meta extends MetaType<TypeDefineType>
  "
>
import { MetaType, TypeDefineType } from "@/autogen/common";
import { FilterBase, TableHelperType } from "@/composables/useTableHelper";
import { createTableComponent } from "./ReportingTableContents";

const TableComponent = createTableComponent<T_Meta, T_Item>(true);

const props = defineProps<{
  table: TableHelperType<T_Item, T_Filter, T_Meta>;
}>();
</script>
